module.exports = __webpack_public_path__ + "static/media/city.ef10b78b.svg";